export default "__VITE_ASSET__uYHbwPsF__"